import { useAuthStore } from '../../stores/authStore'

export default function ProfilePage() {
  const { user } = useAuthStore()

  if (!user) {
    return (
      <div className="rounded-md border border-gray-200 bg-white px-4 py-3 text-sm text-gray-700">
        Loading profile…
      </div>
    )
  }

  return (
    <div className="max-w-xl space-y-4">
      <h1 className="text-xl font-semibold text-gray-900">Your Profile</h1>
      <div className="rounded-lg border border-gray-200 bg-white p-4 space-y-2">
        <div className="flex justify-between text-sm text-gray-700">
          <span>Name</span>
          <span className="font-medium text-gray-900">{user.full_name}</span>
        </div>
        <div className="flex justify-between text-sm text-gray-700">
          <span>Email</span>
          <span className="font-medium text-gray-900">{user.email}</span>
        </div>
        <div className="flex justify-between text-sm text-gray-700">
          <span>Role</span>
          <span className="font-medium text-gray-900">{user.role_display ?? user.role}</span>
        </div>
      </div>
    </div>
  )
}
